import { RouteRecordRaw } from 'vue-router';

const routes = [
  {
    name: 'dashboardTeamActivityDownload',
    path: 'activity-download',
    meta: { title: 'アクション履歴' },
    component: () =>
      import('@/components/dashboard/pages/team-activity-download.vue'),
  },
  {
    name: 'dashboardMemberList',
    path: 'members',
    meta: { title: 'メンバー利用状況' },
    component: () => import('@/components/dashboard/pages/member-list.vue'),
  },
  {
    name: 'download',
    path: 'download',
    meta: { title: 'メンバーの利用状況ダウンロード作成' },
    component: () => import('@/components/dashboard/pages/download.vue'),
  },
];

export const dashboardRouteConfig: RouteRecordRaw = {
  name: 'dashboardHome',
  path: '/dashboard',
  redirect: {
    name: 'dashboardTeamActivityDownload',
  },
  component: () => import('@/components/dashboard/layouts/main.vue'),
  meta: { accessScope: 'authenticated' },
  children: routes,
};
